import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { DialogType } from '../../models/dialog.enum';
import { SimpleModalComponent } from '../sepidzmodal/simple-modal.component';

declare var $: any;


@Component({
  selector: 'ngx-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss']
})
export class ErrorDialogComponent extends SimpleModalComponent<ConfirmModel, boolean> implements OnInit, AfterViewInit, ConfirmModel {
  @Input() title: string = "تست";
  @Input() errorMessage: string = "آزمایشی";
  @Input() dialogType: DialogType = DialogType.alert;
  constructor() {
    super();
  }
  ngAfterViewInit(): void {
  }
  ngOnInit(): void {
    // setTimeout(() => this.setDragable(), 300);
  }
  // setDragable() {
  //   $(document).ready(function () {
  //     let modalContent: any = $('.content');
  //     let modalHeader = $('.modal-header');
  //     modalHeader.addClass('cursor-all-scroll');
  //     modalContent.draggable({
  //       handle: '.modal-header'
  //     });
  //   });
  // }
  cancel() {
    this.closeModal();
  }
  isConfirm(): boolean {
    return this.dialogType && this.dialogType === DialogType.confirm;
  }
  submit(flag: boolean) {
    this.result = flag;
    this.closeModal();
  }
  get message() {
    return this.errorMessage;
  }
}
export interface ConfirmModel {
  title: string;
  errorMessage: string;
  dialogType: DialogType;
}
